import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import OfferSheet from './OfferSheet';
import './OfferPdfModal.css';

/** LAKPED-23: la vista previa del PDF es un pop-up con la hoja y nada más. Los botones de la oferta
 *  ya están en su pantalla. Al imprimir desde aquí sale solo la hoja.
 *
 *  Va en un portal sobre `body`: dentro de la página el `position: fixed` queda atrapado por el
 *  contenedor y el fondo oscuro no llega a tapar la cabecera. */
const OfferPdfModal = ({ oferta, imprimir = false, onClose }) => {
  useEffect(() => {
    const cerrarConEscape = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', cerrarConEscape);
    document.body.classList.add('offer-pdf-abierto');
    return () => {
      window.removeEventListener('keydown', cerrarConEscape);
      document.body.classList.remove('offer-pdf-abierto');
    };
  }, [onClose]);

  // "Descargar PDF" abre el pop-up e imprime en cuanto la hoja está pintada, sin cambiar de pantalla.
  useEffect(() => {
    if (!imprimir) return undefined;
    const timer = setTimeout(() => window.print(), 400);
    return () => clearTimeout(timer);
  }, [imprimir]);

  return createPortal(
    <div className="offer-pdf-modal" onClick={onClose}>
      <div className="offer-pdf-modal-cuerpo" onClick={(e) => e.stopPropagation()}>
        <div className="offer-pdf-modal-acciones">
          <button type="button" className="offer-pdf-modal-boton" onClick={() => window.print()}>
            Descargar PDF
          </button>
          <button type="button" className="offer-pdf-modal-boton" onClick={onClose}>
            Cerrar
          </button>
        </div>
        <OfferSheet oferta={oferta} />
      </div>
    </div>,
    document.body,
  );
};

export default OfferPdfModal;
